import { memo } from "react";
import { Link, generatePath } from "react-router";

import { cn } from "@/lib/chillnn/cn";

import { externalLink } from "@/routes/_constants";
import { PATHS } from "@/routes/paths";

import { AuthSignOutButton } from "@/components/features/auth/sign-out/button";
import { ReOnboardingRequestDialogContainer } from "@/components/features/dialog/re-onboarding-request";

import { useHandleOtherMenu, useHandleReOnboardingRequestDialog } from "./hooks";
import { SideMenuItem } from "../../../_shared/components";
import { OthersIcon } from "../../../_shared/icon";

type Props = {
	hotelID: string;
};

export const SideMenuItemOther = memo(({ hotelID }: Props) => {
	const { tarElRef, canShowOtherMenu, handleChangeCanShowOtherMenu } = useHandleOtherMenu();

	const {
		canShowReOnboardingRequestDialog,
		handleChangeCanShowReOnboardingRequestDialog,
		handleOpenReOnboardingRequestDialog,
	} = useHandleReOnboardingRequestDialog();

	return (
		<div className="fixed bottom-0 w-[205px]">
			<div className="relative h-16 bg-white">
				<div ref={tarElRef}>
					<SideMenuItem
						handleClickButton={handleChangeCanShowOtherMenu}
						title="その他"
						icon={<OthersIcon />}
					/>
				</div>

				{canShowOtherMenu && (
					<ul
						className={cn(
							"absolute bottom-20 flex w-64 flex-col rounded border border-zinc-200 bg-white p-2 text-sm shadow", //
							"animate-in fade-in-60 zoom-in-95 slide-in-from-bottom-2",
						)}
					>
						<li>
							<Link
								to={PATHS.TOP}
								className="block cursor-pointer rounded p-2 hover:bg-zinc-100"
								viewTransition
							>
								ホテル一覧
							</Link>
						</li>
						<li>
							<Link
								to={PATHS.SETUP}
								className="block cursor-pointer rounded p-2 hover:bg-zinc-100"
								viewTransition
							>
								ホテル追加
							</Link>
						</li>
						<li>
							<div
								role="button"
								className="block flex-1 cursor-pointer rounded p-2 hover:bg-zinc-100"
								onClick={handleOpenReOnboardingRequestDialog}
							>
								担当者が変わったときは
							</div>
						</li>
						<li>
							<a
								href={externalLink.chillnnNotion}
								target="_blank"
								className="block cursor-pointer rounded p-2 hover:bg-zinc-100"
							>
								最新情報
							</a>
						</li>
						<li>
							<Link
								to={PATHS.POLICY.SERVICE_POLICY}
								target="_blank"
								className="block cursor-pointer rounded p-2 hover:bg-zinc-100"
								viewTransition
							>
								利用規約
							</Link>
						</li>
						<li className="block cursor-pointer rounded p-2 hover:bg-zinc-100">
							<Link className="block" to={generatePath(PATHS.CANCELLATION, { hotelID })} viewTransition>
								解約する
							</Link>
						</li>
						<li>
							<AuthSignOutButton
								className="block h-[max-content] w-full cursor-pointer rounded p-2 text-left hover:bg-zinc-100"
								variant="no-outline"
							/>
						</li>
					</ul>
				)}
			</div>

			{canShowReOnboardingRequestDialog && (
				<ReOnboardingRequestDialogContainer
					hotelID={hotelID}
					onOpenChange={handleChangeCanShowReOnboardingRequestDialog}
				/>
			)}
		</div>
	);
});
